import { render, staticRenderFns } from "./ConfirmationStep.vue?vue&type=template&id=5a50008c&scoped=true&"
import script from "./ConfirmationStep.vue?vue&type=script&lang=js&"
export * from "./ConfirmationStep.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationStep.vue?vue&type=style&index=0&id=5a50008c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a50008c",
  null
  
)

export default component.exports